import { monthlyRewardsConstants } from './constants';

export const monthlyRewardsReducers = function (state = {}, action) {
    switch (action.type) {
        case monthlyRewardsConstants.GET_MONTHLY_REWARDS_REQUEST:
            return {
                ...state,
                send: true,
                sendMonthlyRewardsGET: true
            };
        case monthlyRewardsConstants.GET_MONTHLY_REWARDS_SUCCESS:
            return {
                ...state,
                send: false,
                sendMonthlyRewardsGET: false
            };
        case monthlyRewardsConstants.GET_MONTHLY_REWARDS_ERROR:
            return {
                ...state,
                errors: action.error,
                send: false,
                sendMonthlyRewardsGET: false
            };
        case monthlyRewardsConstants.PUT_MONTHLY_REWARDS_REQUEST:
            return {
                ...state,
                send: true,
                sendMonthlyRewardsPUT: true
            };
        case monthlyRewardsConstants.PUT_MONTHLY_REWARDS_SUCCESS:
            return {
                ...state,
                send: false,
                sendMonthlyRewardsPUT: false
            };
        case monthlyRewardsConstants.PUT_MONTHLY_REWARDS_ERROR:
            return {
                ...state,
                errors: action.error,
                send: false,
                sendMonthlyRewardsPUT: false
            };
        default:
            return state;
    }
};
